import { useEffect, useState } from "react";
import { Link, useSearch } from "@tanstack/react-router";
import { AuthShell } from "@/components/AuthShell";
import { authApi } from "@/api/endpoints/auth";
import { ApiError } from "@/api/client";
import { translateError } from "@/i18n/errors";

type Status = "loading" | "ok" | "error";

export function VerifyEmailPage(): JSX.Element {
  const search = useSearch({ strict: false }) as { token?: string };
  const [status, setStatus] = useState<Status>("loading");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!search.token) {
      setStatus("error");
      setError(translateError("AUTH_TOKEN_INVALID"));
      return;
    }
    authApi
      .verifyEmail({ token: search.token })
      .then(() => setStatus("ok"))
      .catch((err: unknown) => {
        if (err instanceof ApiError) setError(translateError(err.code, err.message));
        else setError(translateError("COMMON_UNKNOWN"));
        setStatus("error");
      });
  }, [search.token]);

  return (
    <AuthShell sideTitle="Email verification">
      {status === "loading" ? (
        <p>Verifying your email…</p>
      ) : status === "ok" ? (
        <>
          <div>
            <h1>Email verified.</h1>
            <p>Your account is active. You can sign in now.</p>
          </div>
          <Link to="/login" className="btn btn-primary btn-lg btn-block" data-testid="verify-ok">
            Sign in
          </Link>
        </>
      ) : (
        <>
          <div>
            <h1>Link not valid.</h1>
            <p>{error}</p>
          </div>
          <Link to="/login" className="btn btn-outline btn-lg btn-block">
            Back to sign in
          </Link>
        </>
      )}
    </AuthShell>
  );
}
